import React from "react";


const TitleRegister = () => {
  return (
    <div className="title-register__item">
      <h3>
         Register
      </h3>
    </div>
  );
};

export default TitleRegister;
